module.exports = __webpack_public_path__ + "static/media/screen-4.b777a551.webp";